import { useEffect, useState } from 'react';
import {
  FilterChoice,
  SearchFlags,
  SPECIALTY_DENTIST,
  SPECIALTY_FLU_VACCINATIONS,
  SPECIALTY_GENERAL_PRACTICE,
} from '../../../../../common/components/SearchHeader/types/FilterChoice';
import { CovidSpecialtyMessage } from '../../../../CovidSpecialtyMessage/CovidSpecialtyMessage';
import { specialtyIsCovax } from '../../../../CovidSpecialtyMessage/specialtyIsCovax';
import { DentalSpecialtyMessage } from '../../../../DentalSpecialtyMessage/DentalSpecialtyMessage';
import { FluvaxBannerOver65 } from '../../../../SearchPage/FluvaxBanners/FluvaxBannerOver65';
import { BulkBillingInfobox } from './BulkBillingInfobox';
import { TelehealthAfterHourInfoBox } from './TelehealthAfterHourInfoBox/TelehealthAfterHourInfoBox';

interface Props {
  filters: FilterChoice;
}

export const SearchInfobox = ({ filters }: Props) => {
  const [showTeleBanner, setShowTeleBanner] = useState(false);
  const isCovidSearch = specialtyIsCovax(filters.topic?.specialist);

  const showBulkBillingInfobox =
    filters.topic?.bulkBillingGp &&
    filters.topic?.specialist === SPECIALTY_GENERAL_PRACTICE &&
    filters.flag === SearchFlags.TELEHEALTH;

  const between6pmTo6am = () => {
    const currentTime = new Date();
    const sixAm = new Date();
    sixAm.setHours(6, 0, 0);
    const sixPm = new Date();
    sixPm.setHours(18, 0, 0);

    return currentTime > sixPm || currentTime < sixAm;
  };

  const isClientSide = process.browser;

  useEffect(() => {
    setShowTeleBanner(
      isClientSide && // Check to be run client only
        filters.topic?.specialist === SPECIALTY_GENERAL_PRACTICE &&
        filters.flag !== SearchFlags.TELEHEALTH &&
        filters.location?.suburb !== undefined &&
        between6pmTo6am(),
    );
  }, [
    isClientSide,
    filters.flag,
    filters.topic?.specialist,
    filters.location?.suburb,
    setShowTeleBanner,
  ]);

  return (
    <>
      {isCovidSearch && <CovidSpecialtyMessage />}
      {filters.topic?.specialist === SPECIALTY_FLU_VACCINATIONS && <FluvaxBannerOver65 />}
      {filters.topic?.specialist === SPECIALTY_DENTIST && <DentalSpecialtyMessage />}
      {showBulkBillingInfobox && <BulkBillingInfobox />}
      {showTeleBanner && <TelehealthAfterHourInfoBox />}
    </>
  );
};
